import React, { useEffect, useState } from "react";
import { ProfileBeaconIconButton, ProfileBeaconPopover,ProfileBeaconIcon } from "./ProfileBeaconComponents";
import styled from "styled-components";
import {ReactComponent as ToolTipClickedIcon} from "../../assets/TooltipClicked.svg";
import  {ReactComponent as ToolTipIcon } from "../../assets/tooltip.svg";
import  toolTipIcon from "../../assets/tooltip.svg";
import toolTipCloseIcon from "../../assets/TooltipClicked.svg"

const styledProfileIcon = styled(ProfileBeaconIcon) `
background-color: white;
border: 1px solid blue;
`;
const StyledPopoverButton = styled.button`
  background-color: white;
  border: none;
  padding: 0;
  text-align: left;
`;

const StyledActiveStyle = styled.span`
  --beacon-button-space-padding-block-start-normal: 0;
  --beacon-custom-popover-z-index: 1000;
  line-height: 1.5;
  letter-spacing: 0.02px;
  font-size: 18px;
  font-weight: normal;
  border-bottom: 1px dotted #086ea1;
  width: auto;
  color: #ffffff;
  background-color: #086ea1;
  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

const StyledTextAlertsTitle = styled.span`
    color: #3b4b59;
    font-size: 18px;
    font-weight: normal;
    line-height: 1.5;
    letter-spacing: 0.02px;
    border-bottom: 1px dotted #086ea1;
    width: auto;
      @media (max-width: 768px) {
        font-size: 16px;
      }
`;
const Popover = ({ id, label, popoverTitle, popoverContent, onClose, children }) => {
    const [popoverOpen,setPopoverOpen] = useState(false);
    const handleClose= ()=>{
      onClose();
      setPopoverOpen(false);
    }
    return (
        <div className="beacon-on-darker">
            <div  id={id} >

            {(popoverTitle !== " ") && (popoverOpen ?
                    <StyledActiveStyle>{popoverTitle}</StyledActiveStyle> :
                    <StyledTextAlertsTitle>{popoverTitle}</StyledTextAlertsTitle>)}
              {(popoverTitle === " ") && <ProfileBeaconIconButton variant="tertiary" onClick={()=> setPopoverOpen(!popoverOpen)}>Download
               
                    <img slot="icon" src={popoverOpen ? toolTipCloseIcon : toolTipIcon} alt="" />
                    
              </ProfileBeaconIconButton>} 
              </div>
            <ProfileBeaconPopover
            opens-by={'#' + id}
            onClick={handleClose}
            className="cursor-pointer">
           <h2>{popoverTitle}</h2>
           <p>{popoverContent}</p>
        </ProfileBeaconPopover></div>
    );
    }

export default Popover;
